import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import customerInfoReducer from '../../redux/reducers/customer-info-reducer/customer-info-reducer';
import { reducer as formReducer } from 'redux-form';
import { history } from '../history';
import appReducer from './app-reducer/app-reducer';
import registerReducer from '../reducers/register-reducer/register-reducer';
import resetPassReducer from '../reducers/reset-password-reducer/reset-password-reducer';
import insuranceReducer from '../reducers/insurance-info-reducer/insurance-info-reducer';
import applicationInfoUpdateReducer from '../reducers/application-info-update-reducer/application-info-update-reducer';
import agentApplicationInfoReducer from '../reducers/agent-application-info-reducer/agent-application-info-reducer';
import errorReducer from '../reducers/error-reducer/error-reducer';
const rootReducer = combineReducers({
  form: formReducer,
  customerInfoReducer: customerInfoReducer,
  appReducer: appReducer,
  router: connectRouter(history),
  registerReducer: registerReducer,
  insuranceReducer: insuranceReducer,
  applicationInfoUpdateReducer: applicationInfoUpdateReducer,
  agentApplicationInfoReducer: agentApplicationInfoReducer,
  resetPassReducer: resetPassReducer,
  errorReducer: errorReducer,
});

export default (state, action) =>
  rootReducer(action.type === 'LOGOUT' ? undefined : state, action);
